import { useRoomContext } from "@livekit/components-react";
import { LocalAudioTrack, RoomEvent, Track } from "livekit-client";
import React, { useEffect } from "react";

export const AssessmentNoiseFilter = () => {
  const room = useRoomContext();

  useEffect(() => {
    room.on(RoomEvent.LocalTrackPublished, async (trackPublication) => {
      if (trackPublication.source === Track.Source.Microphone && trackPublication.track instanceof LocalAudioTrack) {
        // We recommend a dynamic import to only load the required resources when you enable the plugin
        const { KrispNoiseFilter } = await import("@livekit/krisp-noise-filter");

        // Once instantiated, the filter will begin initializing and will download additional resources
        const krispProcessor = KrispNoiseFilter();
        //console.log("Enabling LiveKit Krisp noise filter");
        await trackPublication.track.setProcessor(krispProcessor);

        // To enable/disable the noise filter, use setEnabled()
        await krispProcessor.setEnabled(true);

        // To check the current status use:
        //console.log("Krisp noise filter is enabled:", krispProcessor.isEnabled());

        // To stop and dispose of the Krisp processor, simply call:
        // await trackPublication.track.stopProcessor()
      }
    });
  }, [room]);

  return <></>;
};
